import { useState } from 'react';

import { Input } from '../../components/Input';
import { useFormState } from '../../lib/useFormState';
import styles from './IssuePanel.module.css';

export type SummaryEditorProps = {
  readonly value: string;
  readonly onSave: (summary: string) => void;
};

/** Инлайновое редактирование заголовка: Enter сохраняет, Escape отменяет. */
export function SummaryEditor({ value, onSave }: SummaryEditorProps) {
  const form = useFormState({ summary: value }, (values) =>
    values.summary.trim().length === 0 ? { summary: 'Введите заголовок' } : {},
  );

  const [isEditing, setEditing] = useState(false);

  if (!isEditing) {
    return (
      <h2
        className={styles['summary']}
        role="button"
        tabIndex={0}
        onClick={() => setEditing(true)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            setEditing(true);
          }
        }}
      >
        {value}
      </h2>
    );
  }

  return (
    <Input
      autoFocus
      value={form.values.summary}
      error={form.errors.summary}
      onChange={(event) => form.setValue('summary', event.target.value)}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          if (form.validate()) {
            onSave(form.values.summary.trim());
            setEditing(false);
          }
        }
        if (event.key === 'Escape') {
          setEditing(false);
        }
      }}
      onBlur={() => {
        if (form.validate() && form.values.summary !== value) {
          onSave(form.values.summary.trim());
        }
        setEditing(false);
      }}
    />
  );
}
